import { observer } from 'mobx-react-lite';
import SizePanel from './SizePanel';
import type { SizePanelProps, SizePanelValueProps } from './types';

export type { SizePanelProps, SizePanelValueProps };
export default observer(SizePanel); // MANUAL OVERRIDE
